import { ModalComponent } from "@/pages/home/Components/Modal";
import { Box, Button, Typography } from "@mui/material";
import style from "./ModalDelete.module.css";

interface ModalDeleteProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => void; // Passando a função de delete via props
}
export function ModalDelete({ open, onClose, onDelete }: ModalDeleteProps) {
  return (
    <ModalComponent open={open} onClose={onClose}>
      <Box className={style.modalHeader}>
        <Typography id="modal-title" variant="h6" component="h2">
          Tem certeza que deseja apagar?
        </Typography>
      </Box>
      <Box className={style.modalFooter}>
        <Button
          variant="contained"
          className={style.buttonSaveClient}
          color="primary"
          onClick={onDelete}
        >
          Apagar
        </Button>
        <Button
          variant="outlined"
          onClick={onClose}
          className={style.buttonCancelClient}
        >
          Cancelar
        </Button>
      </Box>
    </ModalComponent>
  );
}
